import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { CompanyDefaults } from '../models/companyDefaults';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

const getCompanyDefaults = async (): Promise<CompanyDefaults> => {
  const { data } = await axios.get(`${apiUrl}settings/CompanyDefaults`);
  return data;
};

// item 468/469 — company scalar defaults: invoice payment-term days (Net N → past-due calc)
// + annual static budget (drives the MRR-vs-overhead KPI). CustomerSettings rows, no migration.
const useCompanyDefaults = () => {
  const queryClient = useQueryClient();
  const query = useQuery('companyDefaults', getCompanyDefaults);

  const mutation = useMutation(
    (defaults: CompanyDefaults) => axios.post(`${apiUrl}settings/CompanyDefaults`, defaults),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('companyDefaults');
      },
    },
  );

  return {
    ...query,
    defaults: query.data,
    tryUpdate: mutation.mutateAsync,
    isSaving: mutation.isLoading,
  };
};

export default useCompanyDefaults;
